import { useContext } from 'react';
import { styled } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Button from "../../../../customs/Button";
import apiCall from "../../../../utils/apiCall";
import { NotificationContext } from '../../../../providers/notification';

interface ComponentProps {
    RoutePaymentDetails:any;
    handleClose: () => void;
}

const DeleteRoutePayment: React.FC<ComponentProps> = ({ handleClose, RoutePaymentDetails }) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);

    const deleteRoutePayment = (id: number) => {
        return apiCall().delete(`/SetUp/DeleteQualificationById?Id=${id}`);
    };

    const deleteRoutePaymentMutation = useMutation(['delete-RoutePayment'], deleteRoutePayment, {retry: 0});

    const deleteRoutePaymentHandler = async (id : number) => {
        try { 
            await deleteRoutePaymentMutation.mutateAsync(id, {
                onSuccess: () => {
                    showNotification({
                        message: 'Route Payment deleted successfully',
                        type: 'success'
                    })
                    queryClient.refetchQueries(['get-routePayment']);
                    handleClose();
                }
            })
        } catch (error: any) {
            showNotification({
                message: error?.response?.data?.title || error?.message,
                type: 'error',
            })
        }
    };

    const handleDeleteRoutePayment = (id : number) => deleteRoutePaymentHandler(id);

    return (
        <StyledContainer>
            <StyledText>You are about to delete <strong>Payment Order  { RoutePaymentDetails.OrderOfPayment}</strong></StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton  onClick={handleClose}text='Cancel'/>
                    <StyledButton 
                        // onClick={() => handleDeleteRoutePayment()} 
                        type="submit" 
                        text={deleteRoutePaymentMutation.isLoading ? 'Deleting' : 'Yes, Delete'}
                        disabled={deleteRoutePaymentMutation.isLoading}
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DeleteRoutePayment;

const StyledContainer = styled('div')`
    margin-inline: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    background-color: #DD5151;
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`